'use strict';

/*
DOCUMENT ME
*/

define('modules/module.compare.generic',[
  'jquery',
  './module',
  'txt!./module.compare.hbs',
  'storageUtil',
  'zipTools',
  'lib/util/zip',
  'lib/util/tda.config',
  'modernizr',
  'lib/imgix',

  // side effect includes
  'textfit'
], function (
  $,
  Module,
  txtTemplate,
  storageUtil,
  zipTools,
  zip,
  tdaConfig,
  modernizr,
  imgix
) {
  var __isMobile = !!modernizr.mobile;

  var CompareGenericModule = Module.extend({
    template: Handlebars.compile(txtTemplate),
    events: function () {
      return Object.assign({}, Module.prototype.events, {
        'click .module-cta-0': 'onViewClicked',
      });
    },
    staticData: {
      all: {
        image: {
          '1x1': imgix('/assets/img/module/compare/compare-1.jpg', { w: 310 }),
          '2x1': imgix('/assets/img/module/compare/compare-2.jpg', { w: 393 }),
          '3x1': imgix('/assets/img/module/compare/compare-3.jpg', { w: 636 })
        },
        subtextIcon: '/assets/img/module/compare/icon-comparison.svg',
      },
      en: {
        subtext: 'Compare Vehicles',
        headline: 'Competition Toyota',
        copy: {
          '1x1': '<p>Weigh Toyota vs competitors, compare vehicles and see how we stack up.</p>',
          '2x1': '<p>Weigh Toyota vs competitors and see how we stack up. Start by choosing your favorite Toyota and a competitor to compare vehicles and features.</p>'
        },
        actions: [
          {
            title: 'Compare Now',
            url: '/' + tdaConfig.site.context_url + '/compare',
          }
        ],
        copyExtended: {
          intro: 'versus',
          title: 'The Competition'
        }
      },
      es: {
        subtext: 'Comparar Vehículos',
        headline: 'Competidores de Toyota',
        copy: {
          '1x1': '<p>Compara vehículos Toyota con sus competidores y evalúa cómo rendimos.</p>',
          '2x1': '<p>Para comparar con competidores, empieza eligiendo tu Toyota favorito y un competidor.</p>'
        },
        actions: [
          {
            title: 'Comparar aquí',
            url: '/' + tdaConfig.site.context_url + '/compare',
          }
        ],
        copyExtended: {
          intro: 'Contra',
          title: 'la competencia'
        }
      }
    },

    getTemplateContext: function () {
      return $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    onViewClicked: function (e) {
      console.log('onViewClicked');
      if (storageUtil.getTDA() == 'WWW') {
        // If we are on WWW, show the zip dialog
        e.preventDefault();
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
      }
    },

    layout: function () {
      // only needs to happen on 2 & 3 wide modules. at least so far! And not on real mobile devices
      if ( this._config.width !== 1 && !__isMobile ) {
        this.$el.find('.module-headline').textFit({widthOnly: true, maxFontSize: 36, minFontSize: 31, multiLine: true});
      }
    }
  }, {
    configurable: false,
  });

  return CompareGenericModule;
});

